// extracted by mini-css-extract-plugin
export default {"photos-button":"styles_photos-button__AAQWA","photos-button__container":"styles_photos-button__container__25oo2","photos-button__text":"styles_photos-button__text__KMY-W"};